/* eslint-disable import/prefer-default-export */

export const CATEGORY_FILTER_POPUP = 'CATEGORY_FILTER_POPUP';
export const CATEGORY_FILTER_OVERLAY_ID = 'category-filter';
export const KEY_PRICE = 'price';
